import React from 'react';
import { Modal, TFVButton, Translate } from '../../../Share/components';
import './style.scss';
import { isIE } from '../../../Share/utils';
import PropTypes from 'prop-types';

function CopyBookingConfirmation({
  isVisible = true,
  onClose = () => {},
  onConfirm = () => {},
}) {
  return (
    <Modal
      className="tv-copybooking-confirmation__modal"
      onCloseClicked={onClose}
      isVisible={isVisible}
      ieOptionClassName={isIE ? 'ie-fix-height' : ''}
      headerText={Translate({
        content: 'copyBookingConfirmation.title',
      })}
      headerClassName="tv-copybooking-confirmation__modal__header"
    >
      <>
        <div className="tv-copybooking-confirmation__modal__description">
          <Translate content="copyBookingConfirmation.description" />
        </div>
        <div className="d-flex flex-column">
          <div className="tv-workassignment__detail-buttons tv-display-flex">
            <TFVButton
              type="secondary"
              text={Translate({
                content: 'copyBookingConfirmation.confirm',
              })}
              onClick={onConfirm}
            />
            <TFVButton
              type="line-primary"
              className="tv-buttons__element-link"
              text={Translate({
                content: 'copyBookingConfirmation.cancel',
              })}
              onClick={onClose}
            />
          </div>
        </div>
      </>
    </Modal>
  );
}

const propTypes = {
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
  isVisible: PropTypes.bool,
};

CopyBookingConfirmation.propTypes = propTypes;

export default CopyBookingConfirmation;
